// Textos del listado de usuarios de marketing (marketing-users). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    MARKETING_USERS: {
      ACTIONS: {
        EXPORT_CSV: 'Export CSV',
        SOON: 'Soon',
        RELOAD: 'Reload',
        LOADING: 'Loading...',
        RETRY: 'Retry',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        FIRST_PAGE: 'First page',
        LAST_PAGE: 'Last page',
        DONE: 'Done',
        CLOSE: 'Close',
        CLEAR: 'Clear',
        APPLY: 'Apply',
        CLEAR_ALL: 'Clear all',
        REMOVE_FILTER: 'Remove {{label}}',
        CLEAR_SEARCH: 'Clear search',
      },
      FUNNEL: {
        ARIA: 'User funnel',
        FILTERED_BY: 'Data filtered by:',
        LOADING_SUMMARY: 'Loading summary',
        REGISTERED: 'Registered',
        VERIFIED: 'Verified',
        WITH_ROUTINE: 'With pooling routine',
        WITH_FINISHED_ROUTES: 'With finished routes',
        CONV_TOOLTIP: 'Out of all registered users',
        CAE_NOTE: 'with CAE active · {{pct}}% of total',
        PERMISSIONS_TITLE: 'Permissions granted (of {{total}} registered)',
      },
      PERMISSIONS: {
        NOTIFICATION: 'Notifications',
        LOCATION: 'Location',
        BACKGROUND_LOCATION: 'Background location',
        PHYSICAL_ACTIVITY: 'Physical activity',
        BLUETOOTH: 'Bluetooth',
      },
      VIEWS: {
        ARIA: 'View',
        ALL: 'All',
        VERIFIED: 'Verified',
        CAE: 'CAE active',
        ROUTINE: 'With pooling routine',
      },
      PANEL: {
        DEFAULT_TITLE: 'Users',
        ALL_TITLE: 'All users',
        ALL_SUBTITLE: 'Search, filter and choose which columns to show. Click a name to open their profile.',
        VERIFIED_TITLE: 'Verified users',
        VERIFIED_SUBTITLE: 'Users who have completed verification.',
        CAE_TITLE: 'Users with CAE active',
        CAE_SUBTITLE: 'Users with CAE enabled.',
        ROUTINE_TITLE: 'Users with a pooling routine',
        ROUTINE_SUBTITLE: 'Users who have at least one pooling routine.',
      },
      SEARCH: {
        PLACEHOLDER: 'Search by name, surname, email or phone',
        ARIA: 'Search users',
      },
      FILTERS: {
        TITLE: 'Advanced filters',
        VERIFIED: 'Verified',
        CAE_ACTIVE: 'CAE active',
        WITH_ROUTINE: 'With pooling routine',
        MIN_FINISHED: 'Min. finished routes',
        MIN_FINISHED_PLACEHOLDER: 'e.g. 5',
        ROUTE_STATUS: 'Pooling route status',
        DATE_FROM: 'Sign-up date from',
        DATE_TO: 'Sign-up date to',
        DATE_ERROR: 'Check the dates: they must be valid and "To" must be the same as or later than "From".',
        ALL: 'All',
        YES: 'Yes',
        NO: 'No',
        ROUTE_VERIFIED: 'Verified',
        ROUTE_REJECTED: 'Rejected',
      },
      CHIPS: {
        VERIFIED: 'Verified: {{value}}',
        CAE_ACTIVE: 'CAE active: {{value}}',
        WITH_ROUTINE: 'With routine: {{value}}',
        MIN_FINISHED: 'Min. finished routes: {{value}}',
        ROUTE_STATUS: 'Route status: {{value}}',
        DATE_FROM: 'Signed up from: {{value}}',
        DATE_TO: 'Signed up until: {{value}}',
      },
      COLUMNS: {
        EDIT: 'Edit columns',
        NAME: 'Name',
        EMAIL: 'Email',
        PHONE: 'Phone',
        VERIFIED: 'Verified',
        CAE_ACTIVE: 'CAE active',
        FRAUD: 'Fraud',
        COMPANY: 'Company',
        CREATED_AT: 'Sign-up date',
        LAST_ACTIVITY: 'Last activity',
        GENDER: 'Gender',
        BIRTH_DATE: 'Date of birth',
        STRIPE: 'Stripe',
        ACTIVE_VEHICLE: 'Active vehicle',
        ADDRESS_HOME: 'Address (home)',
        ADDRESS_WORK: 'Address (work)',
        DRIVING_LICENSE: 'Driving licence',
        WELCOME_WHATSAPP: 'Welcome WhatsApp',
      },
      TABLE: {
        LOADING_ARIA: 'Loading marketing users',
        EMPTY: 'No users found with the applied filters.',
        LOAD_ERROR: 'Could not load the marketing users list.',
        VERIFIED: 'Verified',
        NOT_VERIFIED: 'Not verified',
        YES: 'Yes',
        NO: 'No',
        GENDER_H: 'Male',
        GENDER_M: 'Female',
        GENDER_O: 'Other',
        ROWS_PER_PAGE: 'Rows per page',
        ROWS_OPTION: '{{n}} rows',
        SHOWING_ONE: 'Showing {{shown}} of {{total}} user',
        SHOWING_OTHER: 'Showing {{shown}} of {{total}} users',
      },
    },
  },
};
